import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';
import Rbac from '../../../../components/Rbac';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transports: [],
      loading: true,
      mode: 'smtp',
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/mailgun-transport');
      if (data.enabled) {
        this.setState({
          mode: 'mailgun',
          transports: [data],
        });
      } else {
        const {data} = await Api.invoke('GET', '/admin-ui/mail-transport');
        this.setState({transports: [data]});
      }
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({loading: false});
    }
  };

  getMailColumns = t => [
    {
      Header: t('Host'),
      accessor: 'host',
    },
    {
      Header: t('Port'),
      accessor: 'port',
    },
    {
      Header: t('User'),
      accessor: 'user',
    },
    {
      Header: t('Password'),
      accessor: 'pass',
      Cell: () => <span>*********</span>,
    },
    {
      Header: t('Actions'),
      width: 60,
      Cell: props => <Link to={{
        pathname: '/dashboard/settings/mailServer/update',
        state: {
          mode: 'smtp',
          transport: props.original,
        },
      }}>
        <i className="simple-icon-pencil edit-icon mx-3 cursor-pointer"/>
      </Link>,
      show: Rbac.hasPermission('update_mail-transport'),
    },
  ];

  getMailgunColumns = t => [
    {
      Header: t('Domain'),
      accessor: 'domain',
    },
    {
      Header: t('Transmitter'),
      accessor: 'from',
    },
    {
      Header: t('API Key'),
      accessor: 'apiKey',
      Cell: () => <span>******************</span>,
    },
    {
      Header: t('Actions'),
      width: 60,
      Cell: props => <Link to={{
        pathname: '/dashboard/settings/mailServer/update',
        state: {
          mode: 'mailgun',
          transport: props.original,
        },
      }}>
        <i className="simple-icon-pencil edit-icon mx-3 cursor-pointer"/>
      </Link>,
      show: Rbac.hasPermission('update_mail-transport'),
    },
  ];

  render() {
    const {t} = this.props;
    const {mode, transports, loading} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  className="-highlight"
                  data={transports}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={mode !== 'mailgun' ? this.getMailColumns(t) : this.getMailgunColumns(t)}
                  pageSize={transports.length || 1}
                  style={{width: '100%'}}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
